export default __webpack_public_path__ + "static/media/prejoinPage_mic.210b2d02.svg";